<template>
    <TemplatePost title="Alterar senha"
                  @close="$router.push({name: 'ListPartners'})"
                  @post="completeRegister"
    >
        <div>
            <FormFields
                    @save="completeRegister"
                    @update:values="inputsValues = $event"
                    :fields="fields"
            />
        </div>
    </TemplatePost>
</template>

<script>
    import TemplatePost from "../../components/TemplatePost";
    import FormFields from "../../components/FormFields";
    import {mapActions, mapMutations} from "vuex";
    export default {
        name: "ResetPassword",
        components: {FormFields, TemplatePost},
        data(){
            return{
                fields:[],
                inputsValues:{},
            }
        },
        mounted() {
            this.fields = [
                {
                    variableName: 'oldPassword',
                    fieldType: 'TextField',
                    label: 'Senha atual',
                    type: 'password',
                    cols: '4',
                },
                {
                    variableName: 'newPassword',
                    fieldType: 'TextField',
                    label: 'Nova senha',
                    type: 'password',
                    cols: '4',
                },
                {
                    variableName: 'confirmNewPassord',
                    fieldType: 'TextField',
                    label: 'Confirmar nova senha',
                    type: 'password',
                    cols: '4',
                },
            ]
        },
        methods:{
            ...mapMutations(["CHANGE_MESSAGE_MODAL", "SET_LOADING"]),
            ...mapActions(["action_alterar_senha"]),
            completeRegister(){
                let {oldPassword, newPassword, confirmNewPassord} = this.inputsValues;

                if(!oldPassword || oldPassword.length === 0){
                    this.CHANGE_MESSAGE_MODAL({
                        show:true,
                        title: 'Atenção',
                        message: `O campo senha atual é obrigatória`,
                        styleMessage: 'danger'
                    });
                }else if(!newPassword || newPassword.length === 0){
                    this.CHANGE_MESSAGE_MODAL({
                        show:true,
                        title: 'Atenção',
                        message: `O campo nova senha é obrigatória`,
                        styleMessage: 'danger'
                    });
                }else if(!confirmNewPassord || confirmNewPassord.length === 0){
                    this.CHANGE_MESSAGE_MODAL({
                        show:true,
                        title: 'Atenção',
                        message: `O campo confirmar nova senha é obrigatória`,
                        styleMessage: 'danger'
                    });
                }else{
                    this.SET_LOADING(true);
                    let obj = {
                        old_password: oldPassword,
                        password: newPassword,
                        password_confirmation: confirmNewPassord
                    };
                    this.action_alterar_senha(obj).then(response => {
                        this.SET_LOADING(false);
                        if(response){
                            this.$router.push({name: 'ListPartners'})
                        }
                    }).catch(() => {
                        this.SET_LOADING(false);
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
